export default "__VITE_ASSET__ORoKPjwl__"